var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../shared/nunjucks.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("C:/Users/alejandro.lorenzo/Desktop/Projects/cloudmine-panel-core/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["templates/critical-error.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"cm-critical-error\">\r\n    <a href=\"//zerolight.com\" title=\"zerolight\" target=\"_blank\" class=\"zl-logo\">\r\n        <img src=\"./images/zl_logo_black.png\">\r\n    </a>\r\n    <h1 class=\"page-header\">Critical error</h1>\r\n    <div>\r\n        <i class=\"fa fa-3x fa-fw fa-frown-o\"></i>\r\n        <div class=\"cm-body\">Billing servers are not available.<br>Please try again later.</div>\r\n    </div>\r\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["templates/critical-error.html"] , dependencies)